import React from "react";
import OutlinedButton from "../Components/OutlinedButton";
const Header: React.FC<Props> = ({background, link, logo, woman}) => {
  return (
    <div
      className={`${background} bg-image w-full h-[90vh] flex 2xl:items-center items-end 2xl:justify-start justify-center 2xl:mt-[100px] mt-[60px] relative`}>
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent pointer-events-none"/>
      <div className="left-0 2xl:ml-40 ml-0 2xl:mb-0 mb-10 flex flex-col items-center justify-center gap-2 relative">
        <div className={`h-[200px] w-[300px] ${logo} bg-image`}/>
        {woman && (
          <div className="flex items-center gap-3 text-white opacity-70">
            <hr className="w-8 border-white"/>
            <span className="text-xs tracking-[0.2em] uppercase">Info costi e servizi</span>
            <hr className="w-8 border-white"/>
          </div>
        )}
        <OutlinedButton href={link} download={false} color="white">Clicca e Prenota Ora</OutlinedButton>
        {/*woman &&<OutlinedButton href={"/Prezzario-Web-Donna.pdf"} downloadName={"Menu MR Trewan"} download={true} color="white">Menù</OutlinedButton>*/}
      </div>

    </div>
  );
};

export default Header;

interface Props {
  background: string,
  link: string,
  logo: string,
  woman:boolean
}